import {
  GET_UNASSIGNED_INCIDENTS_REQUEST,
  GET_UNASSIGNED_INCIDENTS_SUCCESS,
  GET_UNASSIGNED_INCIDENTS_FAIL,
  GET_AUDIT_DETAILS_REQUEST,
  GET_AUDIT_DETAILS_SUCCESS,
  GET_AUDIT_DETAILS_FAIL,
  GET_AUDIT_LOOKUPS_REQUEST,
  GET_AUDIT_LOOKUPS_SUCCESS,
  GET_AUDIT_LOOKUPS_FAIL,
  GET_AUDIT_QUALITY_SUMMARY_DATA_REQUEST,
  GET_AUDIT_QUALITY_SUMMARY_DATA_SUCCESS,
  GET_AUDIT_QUALITY_SUMMARY_DATA_FAIL,
  GET_ALL_INCIDENTS_REQUEST,
  GET_ALL_INCIDENTS_SUCCESS,
  GET_ALL_INCIDENTS_FAIL
} from "../actions/audit";

const initialState = {
  audits: {
    count: 0,
    incidents: [],
    summary: {},
  },
  auditsLoading: false,
  auditsExportLoading: false,
  auditsExportDetails: null,
  auditDetail: null,
  auditDetailLoading: false,
  auditQualitySummaryData: null,
  auditQualitySummaryDataLoading: false,
  auditLookupsLoading: false,
  auditLookups: null
};

export default function audit(state = initialState, action) {
  switch (action.type) {
    
    case GET_AUDIT_LOOKUPS_REQUEST:
      return {
        ...state,
        auditLookupsLoading: true,
      };

    case GET_AUDIT_LOOKUPS_SUCCESS:
      return {
        ...state,
        auditLookupsLoading: false,
        auditLookups: action.payload
      };

    case GET_AUDIT_LOOKUPS_FAIL:
      return {
        ...state,
        auditLookupsLoading: false,
      };
      case GET_AUDIT_QUALITY_SUMMARY_DATA_REQUEST:
        return {
          ...state,
          auditQualitySummaryDataLoading: true,
        };
  
      case GET_AUDIT_QUALITY_SUMMARY_DATA_SUCCESS:
        return {
          ...state,
          auditQualitySummaryDataLoading: false,
          auditQualitySummaryData: action.payload
        };
  
      case GET_AUDIT_QUALITY_SUMMARY_DATA_FAIL:
        return {
          ...state,
          auditQualitySummaryDataLoading: false,
        };
        
    case GET_UNASSIGNED_INCIDENTS_REQUEST:
      return {
        ...state,
        auditsLoading: true,
      };

    case GET_UNASSIGNED_INCIDENTS_SUCCESS:
      return {
        ...state,
        audits: action.payload,
        auditsLoading: false,
      };

    case GET_UNASSIGNED_INCIDENTS_FAIL:
      return {
        ...state,
        auditsLoading: false,
      };

      case GET_ALL_INCIDENTS_REQUEST:
        return {
          ...state,
          auditsExportLoading: true,
        };
  
      case GET_ALL_INCIDENTS_SUCCESS:
        return {
          ...state,
          auditsExportDetails: action.payload,
          auditsExportLoading: false,
        };
  
      case GET_ALL_INCIDENTS_FAIL:
        return {
          ...state,
          auditsExportLoading: false,
        };
  
    case GET_AUDIT_DETAILS_REQUEST:
      return {
        ...state,
        auditDetailLoading: true,
      };

    case GET_AUDIT_DETAILS_SUCCESS:
      return {
        ...state,
        auditDetail: action.payload,
        auditDetailLoading: false,
      };

    case GET_AUDIT_DETAILS_FAIL:
      return {
        ...state,
        auditDetailLoading: false,
      };

    default:
      return state;
  }
}
